export enum FormFields {
  badgeType = 'badgeType',
  text = 'text',
  emoji = 'emoji',
  borderColor = 'borderColor',
  backgroundColor = 'backgroundColor',
  textColor = 'textColor',
  useCustomUsernameColor = 'useCustomUsernameColor',
  usernameTextColor = 'usernameTextColor',
  canBeEarnedByMembers = 'canBeEarnedByMembers',
  removeWhenRulesNoLongerMet = 'removeWhenRulesNoLongerMet',
  giveToSelectedMembers = 'giveToSelectedMembers',
  giveToSelectedTeamStaff = 'giveToSelectedTeamStaff',
  verifiedApplyToType = 'verifiedApplyToType',
  rules = 'rules',
  manuallyAssignedSupporters = 'manuallyAssignedSupporters',
  manuallyAssignedTeamStaff = 'manuallyAssignedTeamStaff',
  commentsWrittenMin = 'commentsWrittenMin',
  commentsWrittenMax = 'commentsWrittenMax',
  likesGivenMin = 'likesGivenMin',
  likesGivenMax = 'likesGivenMax',
  likesReceivedMin = 'likesReceivedMin',
  likesReceivedMax = 'likesReceivedMax',
  gifsGivenMin = 'gifsGivenMin',
  gifsGivenMax = 'gifsGivenMax',
  firstSubscribedAtFrom = 'firstSubscribedAtFrom',
  firstSubscribedAtTo = 'firstSubscribedAtTo',
  memberStreakBadges = 'memberStreakBadges',
  activeMemberAtFrom = 'activeMemberAtFrom',
  activeMemberAtTo = 'activeMemberAtTo',
}

export type TierRule = {
  type: 'Tier'
  tierId?: number
}

export type MemberStreakRule = {
  type: 'MemberStreak'
  monthsFrom?: number
  monthsTo?: number
}

export type CommentsWrittenRule = { type: 'CommentsWritten' }

export type LikesGivenRule = { type: 'LikesGiven' }

export type LikesReceivedRule = { type: 'LikesReceived' }

export type GiftsGivenRule = { type: 'GiftsGiven' }

export type FirstSubscribedAtRule = { type: 'FirstSubscribedAt' }

export type ActiveMemberAtRule = { type: 'ActiveMemberAt' }

export type EmptyRule = { type: 'EmptyRule' }

export type Rules = (
  | TierRule
  | MemberStreakRule
  | CommentsWrittenRule
  | LikesGivenRule
  | LikesReceivedRule
  | GiftsGivenRule
  | FirstSubscribedAtRule
  | ActiveMemberAtRule
  | EmptyRule
)[]

export type MemberStreakBadge = {
  id?: number
  emoji: Emoji
  borderColor?: string
  backgroundColor?: string
  textColor?: string
  monthsFrom: number
  monthsTo: number
}

export type Emoji =
  | {
      type: 'Emoji'
      emojiIcon: string
    }
  | {
      type: 'ImageResource'
      url: string
      imageResourceId?: number
    }

export type FormValues = {
  [FormFields.badgeType]: 'IconAndText' | 'IconOnly' | 'Verified'
  [FormFields.text]: string
  [FormFields.emoji]: Emoji
  [FormFields.borderColor]?: string
  [FormFields.backgroundColor]?: string
  [FormFields.textColor]?: string
  [FormFields.useCustomUsernameColor]?: boolean
  [FormFields.usernameTextColor]?: string
  [FormFields.canBeEarnedByMembers]?: boolean
  [FormFields.removeWhenRulesNoLongerMet]?: boolean
  [FormFields.giveToSelectedMembers]?: boolean
  [FormFields.giveToSelectedTeamStaff]?: boolean
  [FormFields.verifiedApplyToType]?: 'All' | 'Selected'
  [FormFields.rules]: Rules
  [FormFields.manuallyAssignedSupporters]: {
    id: number
    nickname: string
    avatarUrl?: string
  }[]
  [FormFields.manuallyAssignedTeamStaff]: string[]
  [FormFields.commentsWrittenMin]?: string
  [FormFields.commentsWrittenMax]?: string
  [FormFields.likesGivenMin]?: string
  [FormFields.likesGivenMax]?: string
  [FormFields.likesReceivedMin]?: string
  [FormFields.likesReceivedMax]?: string
  [FormFields.gifsGivenMin]?: string
  [FormFields.gifsGivenMax]?: string
  [FormFields.firstSubscribedAtFrom]?: string
  [FormFields.firstSubscribedAtTo]?: string
  [FormFields.activeMemberAtFrom]?: string
  [FormFields.activeMemberAtTo]?: string
  [FormFields.memberStreakBadges]: MemberStreakBadge[]
}
